import React, { useState } from 'react';
import { useNavigate, Navigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { login } from '../api/api';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { user, loginSuccess } = useAuth();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to={user.role === 'admin' ? '/admin' : '/dashboard'} replace />;

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await login(form.email, form.password);
      loginSuccess(res.data.token, res.data.user);
      navigate(res.data.user.role === 'admin' ? '/admin' : '/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || t('Login.Failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      dir={isRTL ? 'rtl' : 'ltr'}
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
      }}
    >
      <div
        style={{
          background: 'white',
          borderRadius: '16px',
          padding: '48px 40px',
          width: '100%',
          maxWidth: '420px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        }}
      >
        <div className="text-center mb-4">
          <img src="/img/logo.png" alt="ENGPI" height="60" />
          <h2 style={{ fontWeight: 700, marginTop: '16px', color: '#1a1a2e' }}>
            {t('Login.Title')}
          </h2>
          <p style={{ color: '#6c757d', fontSize: '14px' }}>
            {t('Login.Subtitle')}
          </p>
        </div>

        {error && (
          <div className="alert alert-danger py-2" role="alert">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-semibold">{t('Login.Email')}</label>
            <input
              type="email"
              className="form-control"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
              placeholder="name@example.com"
              style={{ padding: '10px 14px' }}
            />
          </div>
          <div className="mb-4">
            <label className="form-label fw-semibold">{t('Login.Password')}</label>
            <input
              type="password"
              className="form-control"
              name="password"
              value={form.password}
              onChange={handleChange}
              required
              placeholder="••••••••"
              style={{ padding: '10px 14px' }}
            />
          </div>
          <button
            type="submit"
            className="btn w-100"
            disabled={loading}
            style={{
              background: 'linear-gradient(135deg, #f5a623, #e8920c)',
              color: 'white',
              fontWeight: 600,
              padding: '12px',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
            }}
          >
            {loading ? t('Login.SigningIn') : t('Login.SignIn')}
          </button>
        </form>

        <div className="text-center mt-4">
          <Link
            to="/"
            style={{
              color: '#6c757d',
              fontSize: '14px',
              textDecoration: 'none',
              fontWeight: 500,
            }}
          >
            {t('Login.BackToHome')}
          </Link>
        </div>
      </div>
    </div>
  );
}
